import message from "./modules/message";
import setting from "./modules/setting";
import map from "./modules/map";
import driver from "./modules/driver";
import Layout from "@/layout";

export default [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import(/* webpackChunkName: "login-dashboard" */ "@/views/dashboard"),
        meta: {title: "Dashboard", icon: "dashboard-v2"},
      },
    ]
  },
  {
    path: "/import",
    component: () => import(/* webpackChunkName: "dispatch-import" */ "@/views/dispatchs/dispatch/import"),
  },
  message,
  setting,
  map,
  driver,
  {
    path: "*",
    component: Layout,
  },
]

